import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, ThemeProvider, CssBaseline, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Introduction from './components/Introduction';
import InsuranceShowcase from './components/InsuranceShowcase';
import Calculator from './components/Calculator';
import ContactForm from './components/ContactForm';
import LanguageSwitcher from './components/LanguageSwitcher';
import theme from './theme';
import styles from './styles/App.module.css';
import HomeIcon from '@mui/icons-material/Home';
import CalculateIcon from '@mui/icons-material/Calculate';
import SecurityIcon from '@mui/icons-material/Security';
import ContactMailIcon from '@mui/icons-material/ContactMail';

function App() {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('intro');
  const isMobile = useMediaQuery('(max-width:600px)');

  const renderSection = () => {
    switch (activeSection) {
      case 'intro':
        return <Introduction />;
      case 'insurance':
        return <InsuranceShowcase />;
      case 'calculator':
        return <Calculator />;
      case 'contact':
        return <ContactForm />;
      default:
        return <Introduction />;
    }
  };

  const navItems = [
    { id: 'intro', icon: <HomeIcon />, label: t('nav.intro') },
    { id: 'insurance', icon: <SecurityIcon />, label: t('nav.insurance') },
    { id: 'calculator', icon: <CalculateIcon />, label: t('nav.calculator') },
    { id: 'contact', icon: <ContactMailIcon />, label: t('nav.contact') },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className={styles.root}>
        <AppBar position="static" elevation={0} className={styles.appBar}>
          <Toolbar>
            <Typography variant="h6" component="div" className={styles.logo}>
              TWL
            </Typography>
            {!isMobile ? (
              <>
                <Box className={styles.navContainer}>
                  {navItems.map((item) => (
                    <Button
                      key={item.id}
                      color="inherit"
                      onClick={() => setActiveSection(item.id)}
                      className={`${styles.navButton} ${activeSection === item.id ? styles.navButtonActive : ''}`}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <LanguageSwitcher />
              </>
            ) : (
              <Box sx={{ ml: 'auto' }}>
                <LanguageSwitcher />
              </Box>
            )}
          </Toolbar>
        </AppBar>

        <Container className={`${styles.mainContainer} ${isMobile ? styles.mainContent : ''}`}>
          <Box className={styles.glowEffect} />
          {renderSection()}
        </Container>

        {isMobile && (
          <Box className={styles.navContainer}>
            {navItems.map((item) => (
              <Button
                key={item.id}
                color="inherit"
                onClick={() => setActiveSection(item.id)}
                className={`${styles.navButton} ${activeSection === item.id ? styles.navButtonActive : ''}`}
              >
                {item.icon}
                <Box component="span" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                  {item.label}
                </Box>
              </Button>
            ))}
          </Box>
        )}
      </Box>
    </ThemeProvider>
  );
}

export default App;
